'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _atsi = require('./atsi.html');

var _atsi2 = _interopRequireDefault(_atsi);

var _atsi3 = require('./atsi.controller');

var _atsi4 = _interopRequireDefault(_atsi3);

require('./atsi.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var atsiComponent = {
  restrict: 'E',
  bindings: {},
  template: _atsi2.default,
  controller: _atsi4.default,
  controllerAs: 'vm'
};

exports.default = atsiComponent;


// WEBPACK FOOTER //
// ./client/app/common/reports/atsi/atsi.component.js